// VerifyOtp.js
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import '../../styles.css';

import { verifyOtp } from '../../redux/slices/customerAuthSlice';
import bgSignin from '../../images/bg-signin.jpg';
import logo from '../../images/logo-agc.png';

const VerifyOtp = () => {
  const [otp, setOtp] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { status } = useSelector((state) => state.customer_auth);

  const handleOtpChange = (e) => setOtp(e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (status !== 'loading') {
      const response = await dispatch(verifyOtp(otp));

      if (response.payload && response.payload.status === 'Success') {
        setSuccessMessage(null);
        setErrorMessage(null);
        navigate('/reset-password'); // Redirect to ResetPassword page
      } else if (response.payload && response.payload.status === 'Error') {
        setErrorMessage(response.payload.message);
        setSuccessMessage(null);
      } else {
        setErrorMessage('Unexpected error occurred. Please try again.');
        setSuccessMessage(null);
      }
    }
  };

  return (
    <div className="dashboard-container" id="app-body">
      <div className="bg-signin page-signin" style={{ backgroundImage: `url(${bgSignin})` }}>
        <div className="main-body justify-between">
          <div className="form-body">
            <div className="form-body-container">
              <section id="form" className="form">
                <form onSubmit={handleSubmit}>
                  <div className="logo-signin">
                    <img src={logo} alt="logo" />
                  </div>
                  
                  <div className="form-sigin-wrap">
                    <h3>Verify OTP</h3>
                    <p>Enter the OTP sent to your email.</p>

                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

                    <div className="form-group flex flex-col align-start">
                      <input
                        type="text"
                        id="otp"
                        name="otp"
                        required
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={handleOtpChange}
                      />
                    </div>
                    <div className="form-group">
                      <button type="submit" className="btn">Verify OTP</button>
                    </div>

                    <div className="form-group flex justify-end">
                      <Link className="back-to-login" to="/login">Back to Login</Link>
                    </div>

                  </div>
                </form>
              </section>
            </div>
          </div>
        </div>
        <div className="text-center">
          <p className="text-muted">© 2024 AlexGambleCoaching. Crafted with <i className="mdi mdi-heart text-primary"></i></p>
        </div>
      </div>
    </div>
  );
};

export default VerifyOtp;
